export default "__VITE_PUBLIC_ASSET__6351525a__"